// Mapeamento entre tipos do frontend (português) e banco (inglês)
export const TYPE_MAPPING = {
  'atendimento': 'appointment',
  'disponivel': 'available', 
  'bloqueado': 'blocked',
  'evento': 'event'
} as const;

// Mapeamento reverso: banco → frontend
export const TYPE_MAPPING_REVERSE = {
  'appointment': 'atendimento',
  'available': 'disponivel',
  'blocked': 'bloqueado', 
  'event': 'evento'
} as const;

// Log para verificar mapeamento
console.log('🔍 TYPE_MAPPING carregado:', TYPE_MAPPING);
console.log('🔍 TYPE_MAPPING_REVERSE carregado:', TYPE_MAPPING_REVERSE);

// Validação do mapeamento bidirecional
Object.entries(TYPE_MAPPING).forEach(([pt, en]) => {
  if (TYPE_MAPPING_REVERSE[en] !== pt) {
    console.error('❌ Mapeamento bidirecional falhou:', { pt, en, reverso: TYPE_MAPPING_REVERSE[en] });
  } else {
    console.log('✅ Mapeamento bidirecional válido:', { pt, en, reverso: TYPE_MAPPING_REVERSE[en] });
  }
});

// Tipos válidos para o banco de dados
export type DBEventType = 'appointment' | 'available' | 'blocked' | 'event';

// Tipos válidos para o frontend
export type FrontendEventType = 'atendimento' | 'disponivel' | 'bloqueado' | 'evento';

// Função para converter frontend → banco
export function convertFrontendToDB(eventData: any) {
  console.log('🔍 Dados recebidos do frontend:', eventData);
  
  const { startTime, endTime, createdAt, updatedAt, ...restData } = eventData;
  
  // Função para formatar data/hora para formato ISO válido
  const formatDateTime = (dateTimeStr: string) => {
    if (!dateTimeStr) return null;
    
    try {
      // Limpar string de possíveis caracteres extras
      let cleanStr = dateTimeStr.trim();
      
      // Se já é um formato ISO válido, retorna como está
      if (cleanStr.includes('T') && cleanStr.includes('+')) {
        return cleanStr;
      }
      
      // Se é formato "YYYY-MM-DD HH:MM", converte para ISO
      if (cleanStr.includes(' ') && !cleanStr.includes('T')) {
        const [date, time] = cleanStr.split(' ');
        return `${date}T${time}:00+00:00`;
      }
      
      // Se é apenas data, adiciona horário padrão
      if (cleanStr.includes('-') && !cleanStr.includes(':')) {
        return `${cleanStr}T00:00:00+00:00`;
      }
      
      // Se contém formato inválido com duplicação, tenta extrair apenas a parte válida
      if (cleanStr.includes('+00:00') && cleanStr.includes(' ')) {
        const parts = cleanStr.split(' ');
        if (parts.length >= 2) {
          const isoPart = parts[0];
          if (isoPart.includes('T') && isoPart.includes('+')) {
            return isoPart;
          }
        }
      }
      
      return cleanStr;
    } catch (error) {
      console.error('❌ Erro ao formatar data:', dateTimeStr, error);
      return dateTimeStr;
    }
  };

  // Função para validar formato de data ISO
  const validateISODateTime = (dateTimeStr: string) => {
    if (!dateTimeStr) return false;
    
    try {
      // Verifica se é um formato ISO válido
      const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(:\d{3})?(\+|-)\d{2}:\d{2}$/;
      return isoRegex.test(dateTimeStr);
    } catch (error) {
      return false;
    }
  };
  
  const convertedData = {
    ...restData,
    type: TYPE_MAPPING[eventData.type as FrontendEventType] || 'event',
    start_time: formatDateTime(startTime),
    end_time: formatDateTime(endTime)
  };
  
  // Validação final dos campos de data
  if (convertedData.start_time && !validateISODateTime(convertedData.start_time)) {
    console.warn('⚠️ Formato de start_time inválido:', convertedData.start_time);
  }
  
  if (convertedData.end_time && !validateISODateTime(convertedData.end_time)) {
    console.warn('⚠️ Formato de end_time inválido:', convertedData.end_time);
  }
  
  console.log('🔍 Dados convertidos para banco:', convertedData);
  console.log('🔍 Validação de datas:', {
    start_time_valid: validateISODateTime(convertedData.start_time),
    end_time_valid: validateISODateTime(convertedData.end_time)
  });
  
  return convertedData;
}

// Função para converter banco → frontend
export function convertDBToFrontend(dbEvent: any) {
  console.log('🔍 Dados recebidos do banco:', dbEvent);
  
  // Validar e formatar datas antes da conversão
  const formatDateForFrontend = (dateStr: string) => {
    if (!dateStr) return null;
    
    try {
      // Se é um formato ISO válido, converte para formato legível
      if (dateStr.includes('T') && dateStr.includes('+')) {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          console.warn('⚠️ Data inválida recebida do banco:', dateStr);
          return null;
        }
        return dateStr;
      }
      
      return dateStr;
    } catch (error) {
      console.error('❌ Erro ao formatar data do banco:', dateStr, error);
      return null;
    }
  };
  
      const convertedData = {
      ...dbEvent,
      type: TYPE_MAPPING_REVERSE[dbEvent.type as DBEventType] || 'evento',
      startTime: formatDateForFrontend(dbEvent.start_time),
      endTime: formatDateForFrontend(dbEvent.end_time),
      createdAt: dbEvent.created_at,
      updatedAt: dbEvent.updated_at
    };
    
    console.log('🔍 convertDBToFrontend: dados convertidos para frontend:', convertedData);
    console.log('🔍 convertDBToFrontend: mapeamento de tipo:', {
      original: dbEvent.type,
      mapeado: TYPE_MAPPING_REVERSE[dbEvent.type as DBEventType] || 'evento',
      mapeamentoDisponivel: Object.keys(TYPE_MAPPING_REVERSE)
    });
    
    return convertedData;
}
